/**
 * Translation language options are only meaningful when at least one subtitle
 * track exists. Empty `subtitles: []` (SPA nav clear / homepage) must not load
 * Google/Azure/… tables into `selections.translations`.
 */
export function shouldLoadTranslationLanguageOptions(subtitles: unknown): boolean {
  return Array.isArray(subtitles) && subtitles.length > 0;
}
